import Vue, { VNode } from 'vue';
import { Component } from 'vue-property-decorator';

import './SplitLayout.scss';

@Component({ name: 'SplitLayout' })
export class SplitLayout extends Vue {
  render(): VNode {
    return (
      <div class="lp-split-layout">
        {this.$slots.default}
      </div>
    );
  }
}
